import { InjectionToken } from '@angular/core';
import { DatalayerUtilsService } from 'ib-web-commons/app/core/ib-datalayer/services/ib-datalayer-utils-service';
import { upgradeAJSServiceProvider } from 'ib-web-commons/utils'; 
export const AJSGiftCardsDatalayerUtilsService = new InjectionToken('DatalayerUtilsService');
export const AJSGiftCardsDatalayerUtilsServiceProvider = upgradeAJSServiceProvider('DatalayerUtilsService', AJSGiftCardsDatalayerUtilsService);
export interface GiftCardsDatalayerUtilsServiceType extends DatalayerUtilsService {
    initializeDatalayer(language, market, deviceType)
    addDataLayerInfo(dataLayerInfo)
    updateDatalayerWithQuadrigam(quadrigam, extendedObject, isUserLogged)
    sendDatalayerEvent(type)
}
